import React from "react";
import {
  Box,
  Typography,
  TextField,
  Paper,
  TableCell,
  TableRow,
  TableBody,
  Table,
} from "@mui/material";
import MKBox from "components/MKBox";

function Contract() {
  return (
    <MKBox py={3} px={2} bgcolor="#fff">
      {/* 1. 기본사항 */}
      <Typography variant="h6" fontWeight="bold" mb={2}>
        1. 기본사항
      </Typography>
      <Paper elevation={1} sx={{ p: 3, mb: 3 }}>
        <Table sx={{ width: "100%", border: "1px solid #ddd" }}>
          <TableBody>
            {/* 성명, 상호명 */}
            <TableRow>
              <TableCell sx={{ width: "20%", textAlign: "center", backgroundColor: "#f9f9f9" }}>
                <Typography variant="body2">성명</Typography>
              </TableCell>
              <TableCell sx={{ width: "30%" }}>
                <TextField variant="standard" fullWidth />
              </TableCell>
              <TableCell sx={{ width: "20%", textAlign: "center", backgroundColor: "#f9f9f9" }}>
                <Typography variant="body2">상호명</Typography>
              </TableCell>
              <TableCell sx={{ width: "30%" }}>
                <TextField variant="standard" fullWidth />
              </TableCell>
            </TableRow>
            {/* 전화번호, 핸드폰 */}
            <TableRow>
              <TableCell sx={{ textAlign: "center", backgroundColor: "#f9f9f9" }}>
                <Typography variant="body2">전화번호</Typography>
              </TableCell>
              <TableCell>
                <TextField variant="standard" fullWidth />
              </TableCell>
              <TableCell sx={{ textAlign: "center", backgroundColor: "#f9f9f9" }}>
                <Typography variant="body2">핸드폰</Typography>
              </TableCell>
              <TableCell>
                <TextField variant="standard" fullWidth />
              </TableCell>
            </TableRow>
            {/* 주소 */}
            <TableRow>
              <TableCell sx={{ textAlign: "center", backgroundColor: "#f9f9f9" }}>
                <Typography variant="body2">주소</Typography>
              </TableCell>
              <TableCell colSpan={3}>
                <TextField variant="standard" fullWidth />
              </TableCell>
            </TableRow>
            {/* 사업자번호, 소재지 */}
            <TableRow>
              <TableCell sx={{ textAlign: "center", backgroundColor: "#f9f9f9" }}>
                <Typography variant="body2">사업자번호</Typography>
              </TableCell>
              <TableCell>
                <TextField variant="standard" fullWidth />
              </TableCell>
              <TableCell sx={{ textAlign: "center", backgroundColor: "#f9f9f9" }}>
                <Typography variant="body2">소재지</Typography>
              </TableCell>
              <TableCell>
                <TextField variant="standard" fullWidth />
              </TableCell>
            </TableRow>
            {/* 설립년월, 직원수 */}
            <TableRow>
              <TableCell sx={{ textAlign: "center", backgroundColor: "#f9f9f9" }}>
                <Typography variant="body2">설립년월</Typography>
              </TableCell>
              <TableCell>
                <TextField variant="standard" fullWidth />
              </TableCell>
              <TableCell sx={{ textAlign: "center", backgroundColor: "#f9f9f9" }}>
                <Typography variant="body2">직원수</Typography>
              </TableCell>
              <TableCell>
                <TextField variant="standard" fullWidth />
              </TableCell>
            </TableRow>
            {/* 주종목, 홈페이지 */}
            <TableRow>
              <TableCell sx={{ textAlign: "center", backgroundColor: "#f9f9f9" }}>
                <Typography variant="body2">주종목</Typography>
              </TableCell>
              <TableCell>
                <TextField variant="standard" fullWidth />
              </TableCell>
              <TableCell sx={{ textAlign: "center", backgroundColor: "#f9f9f9" }}>
                <Typography variant="body2">홈페이지</Typography>
              </TableCell>
              <TableCell>
                <TextField variant="standard" fullWidth />
              </TableCell>
            </TableRow>
            {/* 대리점 희망지역 */}
            <TableRow>
              <TableCell sx={{ textAlign: "center", backgroundColor: "#f9f9f9" }}>
                <Typography variant="body2">대리점 희망지역</Typography>
              </TableCell>
              <TableCell colSpan={3}>
                <TextField variant="standard" fullWidth />
              </TableCell>
            </TableRow>
            {/* 인터넷 판매 시 매출액 */}
            <TableRow>
              <TableCell sx={{ textAlign: "center", backgroundColor: "#f9f9f9" }}>
                <Typography variant="body2">인터넷 판매 시 매출액</Typography>
              </TableCell>
              <TableCell colSpan={3}>
                <Box display="flex" alignItems="center">
                  <TextField variant="standard" fullWidth sx={{ width: "50%", marginRight: 2 }} />
                  <Typography variant="body2">원</Typography>
                </Box>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Paper>

      {/* 2. 협업계획 */}
      <Typography variant="h6" fontWeight="bold" mb={2}>
        2. 협업계획
      </Typography>
      <Box p={2} border="1px solid #ddd" borderRadius={2} mb={3}>
        <Typography variant="body2" gutterBottom>
          협업계획(생산, 연구개발, 마케팅, 전문적 역할을 분담해 상호 보완적으로 제품을 개발,
          생산하는 내용입니다.)
        </Typography>
        <Typography variant="body2" color="text.secondary" mb={2}>
          협업 내용을 상세히 적어 주세요.
        </Typography>
        <TextField
          multiline
          rows={6}
          fullWidth
          placeholder="협업 내용을 작성하세요."
          variant="outlined"
        />
      </Box>

      {/* 개인정보 수집 활용 동의서 */}
      <Typography variant="h6" fontWeight="bold" mb={2}>
        [개인정보 수집 활용 동의서]
      </Typography>
      <Box p={2} border="1px solid #ddd" borderRadius={2} mb={3}>
        <Typography variant="body2" mb={1}>
          귀하는 아래의 내용을 확인하고 다음과 같이 귀하의 개인정보를 제공하고 처리하는 것에
          동의합니다.
        </Typography>
        <Typography variant="body2" mb={1}>
          1. 개인정보의 선택적 수집 및 이용에 대한 동의
        </Typography>
        <Typography variant="body2" mb={1}>
          2. 귀하의 성명, 사업자번호, 주소, 전화번호, 휴대전화번호, 이메일주소는 서비스 제공, 관리,
          세일즈 지원 목적으로 활용됩니다.
        </Typography>
        <Typography variant="body2" mb={1}>
          3. 본 동의를 부여함에 있어, 귀하는 해당 내용에 동의하지 않을 수 있습니다.
        </Typography>
        <Typography variant="body2" mb={3}>
          4. 위 개인정보 수집 및 이용에 동의합니다.
        </Typography>
        <Box display="flex" justifyContent="flex-end">
          <Typography variant="body2" mr={2}>
            신청인 :
          </Typography>
          <TextField size="small" placeholder="서명" />
        </Box>
      </Box>
    </MKBox>
  );
}

export default Contract;
